<div class="custom-alert">
    <div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
        <a class="close custom-close" (click)="removeAlert(alert)">&times;</a>
        <span [innerHTML]="alert.message"></span>
    </div>
</div>

<div *ngIf="notifications?.length > 0" class="notification">
    <div *ngFor="let notification of notifications" class="{{cssClass(notification)}}">
        <a class="close custom-close" (click)="removeNotification(notification)">&times;</a>
        <span class="notification-title" [innerHTML]="notification.title"></span>
        <span class="notification-message" [innerHTML]="notification.message"></span>
    </div>
</div>
